import { useAuthorStore } from '@/stores';

/**
 * @typedef {import('vue-router').Router} VueRouter
 * @typedef {import('vue-router').RouteLocationNormalized} RouteLocationNormalized
 */

/**
 * @typedef {import('./app-router').AppRouter} AppRouter
 */

const whiteList = [ '/login', '/register', '/not-found', '/404', '/role-perm-error', '/perm-error' ];

/**
 * 是否是白名单路由
 * @param {RouteLocationNormalized} r
 * @returns {boolean}
 */
const isWhiteRoute = (r) => whiteList.includes(r.path);

/**
 * 权限路由守卫
 * @param {AppRouter} app
 */
export const permissionGuard = (app) => {
    const router = app.router;
    // 在此处回调做检查控制
    router.beforeEach(async (to, from, next) => {
        const authorStore = useAuthorStore();
        const {
            token,
            user,
            roles: userRoles = [],
        } = authorStore;

        const { meta: { requireAuth = false } = {}, roles: routeRoles = [] } = to;
        const { id: userId = '' } = user || {};
        if (token && user) {
            if (!app.isReady) {
                const b = await app.updateRoleRoutes(userId, userRoles);
                if (b) {
                    next({ ...to, replace: true });
                    return;
                }
                if (isWhiteRoute(to)) {
                    return next();
                }
                return next(false);
            }
            if (to.path === '/login') {
                // 已登录，不允许再进入登录页面
                return next({ path: '/', replace: true });
            }
            if (routeRoles && Array.isArray(routeRoles) && routeRoles.length > 0) {
                // 检查用户角色
                if (routeRoles.some(role => userRoles.includes(role))) {
                    return next();
                }
                if (to.path !== '/role-perm-error') {
                    // 无权操作
                    return next({ path: '/role-perm-error', replace: true });
                }
            }
            // 路由已准备就准，直接进入
            return next();
        }
        // 未登录时处理
        if (to.path === '/') {
            // 未登录时，不允许进入根路径
            return next({ path: `login?redirect=${to.path}`, replace: true });
        }
        if (requireAuth && !token) {
            if (isWhiteRoute(to)) {
                return next();
            }
            if (!app.isReady) {
                const b = await app.updateRoleRoutes('', []);
                if (b) {
                    return next({ ...to, replace: true });
                }
                if (isWhiteRoute(to)) {
                    return next();
                }
                return next(false);
            }
            return next({ path: `login?redirect=${to.path}`, replace: true });
        }
        // 未登录、或不需要登录权限时直接进入
        next();
    });
};
